import FormattedMessage from 'I18n/components/FormattedMessage';
import { Badge } from 'foundations-components/transitional/components/Badge';
import { jsx as _jsx } from "react/jsx-runtime";
const FeatureTableBadge = ({
  use = 'new',
  translationKey = 'recommended'
}) => {
  return /*#__PURE__*/_jsx(Badge, {
    use: use,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `badges.${translationKey}`
    })
  });
};
export default FeatureTableBadge;